import { useCallback, useEffect, useState } from 'react';
import { getLockRemainingMs } from './authThrottle';

/**
  Temps restant (ms) avant de pouvoir retenter pour les cles donnees, rafraichi
  chaque seconde tant qu'un verrou court. `refresh` se rappelle apres avoir
  enregistre un echec ou pose un delai, pour que le compte a rebours demarre.
*/
export function useLockCountdown(keys: string[]) {
  const keysSignature = keys.join('\u0000');
  const read = useCallback(
    () => getLockRemainingMs(keysSignature ? keysSignature.split('\u0000') : []),
    [keysSignature],
  );
  const [remainingMs, setRemainingMs] = useState(read);

  const refresh = useCallback(() => setRemainingMs(read()), [read]);

  useEffect(() => {
    refresh();
  }, [refresh]);

  useEffect(() => {
    if (remainingMs <= 0) return;
    const timer = window.setTimeout(refresh, Math.min(1000, remainingMs));
    return () => window.clearTimeout(timer);
  }, [remainingMs, refresh]);

  return { remainingMs, isLocked: remainingMs > 0, refresh };
}
